import { apiSlice } from "..";
import { getToken } from "shared/utils/getToken";

const resultadoQuestionarioSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    importarResultadoQuestionario: build.mutation<void, File>({
      query: (arquivo) => {
        const formData = new FormData();
        formData.append("arquivo", arquivo);

        return {
          url: "resultado-questionario/importar",
          method: "POST",
          headers: { Authorization: `Bearer ${getToken()}` },
          body: formData,
        };
      },
      invalidatesTags: ["Inscricoes"],
    }),
  }),
  overrideExisting: false,
});

export const { useImportarResultadoQuestionarioMutation } = resultadoQuestionarioSlice;
